var assign = require('object-assign');
var Q = require('q');
var Raven = require('../Raven');
var request = require('superagent');
var vsprintf = require('sprintf-js').vsprintf;

var AppDispatcher = require('../dispatchers/AppDispatcher');
var Constants = require('../constants/Constants');

function Api (options) {
    this.options = assign({}, this.options, options || {});
}

Api.prototype.options = {
    base_url: ''
};

Api.prototype.createRequest = function(method, url, query, params, customHeaders) {
    var req = request(method, url)
        .type('application/json')
        .accept('application/json');

    Object.keys(customHeaders||{}).forEach(function (headerName) {
        req.set(headerName, customHeaders[headerName]);
    });

    if (query || false) {
        req.query(query);
    }

    if (params || false) {
        req.send(params);
    }

    return req;
};
Api.prototype.dispatch = function(key, state, response, params) {
    var payload = {
        actionType: key,
        response: response,
        state: state
    };

    if (params) {
        payload.params = params;
    }

    // Break out of the promise chain so any errors while dispatching
    // bubble up to the root React render call
    setTimeout(function () {
        AppDispatcher.handleRequestAction(payload);
    }, 0);
};
Api.prototype.handleRequestError = function (key, url) {
    return function (data) {
        var response = data.res;
        // We dont care about 400, 404 or 410 errors, but care about the rest.
        if (!response || (response.status >= 400 && (![400, 404, 410].includes(response.status)))) {
            var message = response && response.body && response.body.message ?
                response.body.message : data.err;

            try {
                throw new Error(message);
            } catch (e) {
                Raven.captureException(e, {
                    tags: {
                        request_key: key
                    },
                    extra: {
                        body: (response && response.text) ?
                            JSON.stringify(response.text.substr(0, 200)) :
                            'Unknown body',
                        err: data.err,
                        url: url
                    }
                });
            }
        }

        throw data;
    };
};
Api.prototype.makeUrl = function(url, arguments) {
    if (arguments || false) {
        url = vsprintf(url, arguments);
    }

    return this.options.base_url + url;
};
Api.prototype.send = function(key, method, url, query, params, eventParams, customHeaders) {
    this.sendAndDispatchPromise(key, method, url, query, params, eventParams, customHeaders).done();
};
Api.prototype.sendAndDispatchPromise = function(key, method, url, query, params, eventParams, customHeaders) {
    eventParams = assign({}, query, params, eventParams);
    this.dispatch(key, Constants.request.PENDING, null, eventParams);

    var dispatch = this.dispatch;
    var promise = this.sendPromise(key, method, url, query, params, customHeaders);
    var options = this.options;

    return promise.then(function (res) {
        dispatch(key, Constants.request.FINISHED, res, eventParams);

        return res
    }.bind(this), function(data) {
        var err = data.err;
        var res = data.res;

        if (err && err.timeout === options.timeout) {
            dispatch(key, Constants.request.TIMEOUT, null, eventParams);

            return data;
        }

        var constant = (res && (res.status === 403 || res.status === 401)) ?
            Constants.request.DENIED :
            Constants.request.ERROR;

        dispatch(key, constant, res, eventParams);

        throw data;
    }.bind(this));
};
/**
 * Does not dispatch this request through the AppDispatcher
 */
Api.prototype.sendPromise = function(key, method, url, query, params, customHeaders) {
    const req = this.createRequest(method, url, query, params, customHeaders);

    var promise = Q.Promise(function (resolve, reject) {
        var handleRequest = function(err, res) {
            if (err || typeof res == "undefined" || res.status >= 400 || !res.ok) {
                reject({ err: err, res: res, req: req });

                return;
            }

            resolve(res);
        };

        req.end(handleRequest);
    });

    return promise.catch(this.handleRequestError(key, url));
};

module.exports = Api;



// WEBPACK FOOTER //
// ./app/api/Base.js